<template>
    <main>
        <section>
            <div class="content-960">
                <div class="row">
                    <section class="col-sm-12">
                        <button class="btn-large-40 btn-success uppercase pull-right btn-header" @click="openCreate()">
                            Criar
                        </button>
                    </section>
                </div>
            </div>

            <div class="content-960 mobile-row">
                <div class="wrapper-960 clearfix">
                    <div class="titles icons icon-news-middle">
                        <h2 class="uppercase"><b>Modalidade</b></h2>
                    </div>

                    <div class="form-group col-md-12">
                        <label for="modalidadeId">Modalidade</label>
                        <select v-select="{ dataitem: 'Modalidade', default: 'Selecione' }" v-model="filter.modalidadeId" class="form-control" name="modalidadeId"></select>
                    </div>

                </div>
                <button type="button" class="btn-large-40 btn-red uppercase" @click="executeFilter(filter)">Buscar</button>
               
            </div>
            <br />
            <div class="table-responsive standard-table header-cinza">
                <table>
                    <thead>
                        <tr>
                            <th>Instituição de Ensino</th>
                            <th>Modalidade</th>

                            <th class="text-center" width="150"><i class="fa fa-cog"></i></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in result.items" v-bind:key="item.tagJobsId" class="animated fadeIn">
                            <td>{{ item.modalidade.nome }}</td>
                            <td>{{ item.modalidade.nome }}</td>

                            <td class="text-center">
                                <button type="button" class="btn btn-sm btn-primary" @click="openEdit({ instituicaoEnsinoModalidadeId: item.instituicaoEnsinoModalidadeId })">
                                    <i class="fa fa-pencil"></i>
                                </button>
                                <button type="button" class="btn btn-sm btn-danger" @click="openRemove({ instituicaoEnsinoModalidadeId: item.instituicaoEnsinoModalidadeId })">
                                    <i class="fa fa-trash-o"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="card-block no-padding">
                <pagination :total="result.total" :page-size="filter.pageSize" :callback="executePageChanged"></pagination>
            </div>

        </section>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogCreate" :hide-footer="true" title="Criar">
            <form-create :id="id" v-if="dialogCreate" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogEdit" :hide-footer="true" title="Editar">
            <form-edit v-if="dialogEdit" :id="instituicaoEnsinoModalidadeId" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogRemove" title="Confirmação">
            <p>Tem certeza que deseja remover este item?</p>
            <div slot="modal-footer">
                <button class="btn btn-sm btn-danger" @click="executeRemove()">
                    Remover
                </button>
            </div>
        </b-modal>

    </main>

</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    import formCreate from './form-create'
    import formEdit from './form-edit'

    export default {
        name: 'instituicaoensinomodalidade',
        mixins: [base],
        props: { id: Number },
        components: { formCreate, formEdit },
        data() {
            return {

                resources: {
                    filter: 'instituicaoensinomodalidade',
                    remove: 'instituicaoensinomodalidade'
                },

                dialogRemove: false,
                dialogCreate: false,
                dialogEdit: false,

                model: {},
                filter: {
                    instituicaoEnsinoModalidade: {},
                    pageSize: 50,
                    pageIndex: 1,
                    isPagination: true,
                },

                result: {
                    total: 0,
                    items: []
                }
            }
        },
        methods: {
            openEdit: function (model) {
                this.instituicaoEnsinoModalidadeId = model.instituicaoEnsinoModalidadeId;
                this.dialogEdit = true;
            },
            openCreate: function () {
                this.dialogCreate = true;
            },
            onSaved: function () {
                this.hideAll();
                this.executeLoad();
            },
            hideAll: function () {
                this.dialogCreate = false;
                this.dialogEdit = false;
                this.dialogRemove = false;
            },

            openRemove: function (model) {
                this.dialogRemove = true;
                this.model = model;
            },
            executeRemove: function (model) {
                if (model) this.model = model;
                new Api(this.resources.remove).delete(this.model).then(() => {
                    this.defaultSuccessResult("Item removido com sucesso");
                    this.hideAll();
                    this.executeLoad();
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            executeFilter: function (filter) {
                if (filter) this.filter = filter;
                this.executeLoad();
            },
            executePageChanged: function (index) {
                this.filter = this.defaultPageChanged(this.filter, index);
                this.executeLoad();
            },
            executeOrderBy: function (field) {
                this.filter.instituicaoEnsinoId = this.id;
                this.filter = this.defaultOrderBy(this.filter, field);
                this.executeLoad();
            },
            executeLoad: function () {
                this.showLoading();
                this.filter.instituicaoEnsinoId = this.$props.id;
                new Api(this.resources.filter).get(this.filter).then(data => {
                    if (data.summary) this.result.total = data.summary.total;
                    this.result.items = data.dataList;
                    this.hideLoading();
                }, (err) => {
                    this.failLoading();
                    if (err && err.data && err.data.errors) {
                        this.$eventHub.$emit('show-notification', {
                            type: 'error',
                            title: 'Atenção',
                            text: err.data.errors[0]
                        })
                    }
                });
            },

        },

        mounted() {
            this.executeFilter();
        }

    };
</script>